(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'CpcentralNotificationSearch',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		$('.cpcentral-notifications-dates').on('click', function _dateClick(e) {
			var filter          = $(this).data('filter'),
				from            = $('#cpcentralnotificationsearch-from_date').data('DateTimePicker'),
				month_start     = moment().startOf('month').format("MM/DD/YYYY"),
				this_year_start = moment().startOf('year').format("MM/DD/YYYY"),
				this_week_start = moment().startOf('week').format("MM/DD/YYYY");

			e.preventDefault();

			switch (filter) {
				case 'this-week':
					from.date(this_week_start);
					break;
				case 'this-month':
					from.date(month_start);
					break;
				case 'this-year':
					from.date(this_year_start);
					break;
				default:
					break;
			}
		});
	};
}(jQuery, window.Adzuki || {}));
